const fmt = (n) => Number(n || 0).toLocaleString("en-US");

export default function NuevosPorSucursal({ rows }) {
  const total = rows.reduce((a, r) => a + r.count, 0);
  return (
    <div className="mt-6 pt-4 border-t border-gray-100" data-testid="sp-funnel-nuevos-sucursal">
      <div className="flex items-baseline justify-between mb-2">
        <h4 className="label-up text-[11px]" style={{ color: "#f97316" }}>
          Leads abiertos · Nuevo por sucursal
        </h4>
        <span className="text-xs font-bold text-gray-500" data-testid="sp-funnel-nuevos-total">
          {fmt(total)} sin trabajar
        </span>
      </div>
      {rows.length === 0 ? (
        <div className="text-xs text-gray-400 font-semibold" data-testid="sp-funnel-nuevos-empty">
          Ninguna sucursal tiene leads en estado Nuevo.
        </div>
      ) : (
        <div className="max-h-48 overflow-y-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="text-left text-gray-400 uppercase text-[10px] tracking-wider">
                <th className="py-1 font-extrabold">Sucursal</th>
                <th className="py-1 font-extrabold text-right">Leads Nuevo</th>
                <th className="py-1 font-extrabold text-right">%</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.sucursal} className="border-t border-gray-50"
                    data-testid={`sp-funnel-nuevos-row-${r.sucursal}`}>
                  <td className="py-1.5 font-semibold text-gray-700">{r.sucursal}</td>
                  <td className="py-1.5 text-right font-extrabold" style={{ fontVariantNumeric: "tabular-nums" }}>{fmt(r.count)}</td>
                  <td className="py-1.5 text-right text-gray-500">{total ? ((r.count / total) * 100).toFixed(1) : 0}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
